import React from 'react';
import styled from 'styled-components';
import {BodyFour} from '@/styles/theme/default/typography';
import {isPreOrder} from "@/models/product";

const Wrapper = styled.div``;

function InventoryLeft({className, product}) {
  const usesInventory = product?.uses_inventory;
  const currentInventory = product?.current_inventory;
  const inventoryThreshold = product?.inventory_threshold;
  const isPurchasable = product?.is_purchasable;

  if (isPreOrder(product?.id)) {
    return null;
  }

  if (!usesInventory || !isPurchasable || currentInventory >= inventoryThreshold * 3) {
    return null;
  }

  return (
    <Wrapper className={className ?? ''}>
      <BodyFour className="inventory-left" color="#A83569">
        Only {currentInventory} left in stock - order soon!
      </BodyFour>
    </Wrapper>
  );
}

export default InventoryLeft;
